
































import {Component, Prop, Vue} from 'vue-property-decorator';
import {ClaimType} from '@/types/claim';
import {isCancelClaim, isExchangeClaim, isReturnClaim,} from '@/components/claim/popup/validations';

@Component({
  computed: {
    isCancelClaim,
    isExchangeClaim,
    isReturnClaim,
  }
})
export default class NoticeBox extends Vue{
  @Prop({required: true})
  private claimType!: ClaimType
}
